module.exports = __webpack_public_path__ + "img/ИФ-1(А)-028.ba1472e7.png";